import { render } from "./ReadonlyProduct.vue?vue&type=template&id=ad1eb51a"
import script from "./ReadonlyProduct.vue?vue&type=script&lang=js"
export * from "./ReadonlyProduct.vue?vue&type=script&lang=js"

import "./ReadonlyProduct.vue?vue&type=style&index=0&id=ad1eb51a&lang=css"

import exportComponent from "/home/collin/workspace/elands/elandsweb/main-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__